// client/src/hooks/usePageTracking.ts
// Emits a GA4 page_view + Clarity `screen` tag on every route change. Mount ONCE,
// inside the Router (it uses useLocation).
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { setScreen } from '../lib/analytics';
import { screenNameForPath } from '../lib/screenNames';

export function usePageTracking(): void {
  const location = useLocation();
  const lastRef = useRef<string>('');

  useEffect(() => {
    const name = screenNameForPath(location.pathname);
    // Fire once per (screen, path); ignore query-only changes.
    const key = `${name}::${location.pathname}`;
    if (key === lastRef.current) return;
    lastRef.current = key;
    setScreen(name, location.pathname);
  }, [location.pathname]);
}
